export const DropboxFileProviderDisplayName = "Bkc";
export const BoxFileProviderDisplayName = "Ckc";
export const GoogleDriveFileProviderDisplayName = "Dkc";
export const FacebookFileProviderDisplayName = "Ekc";
export const RecentAttachmentsFileProviderDisplayName = "Fkc";
export const EgnyteFileProviderDisplayName = "Gkc";
export default {DropboxFileProviderDisplayName,BoxFileProviderDisplayName,GoogleDriveFileProviderDisplayName,FacebookFileProviderDisplayName,RecentAttachmentsFileProviderDisplayName,EgnyteFileProviderDisplayName};